<template>
<v-app>
    <v-main>
      <!--Laptop loader -->
      <!-- <div class="hidden-md-and-down" style="margin:4% auto auto auto;width:630px">
      <v-skeleton-loader v-if="loading" type="list-item-avatar"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="card-avatar"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="card-avatar"></v-skeleton-loader>
        </div> -->
        <!--Mobile loader -->
        <!-- <div class="hidden-lg-and-up" style="margin:4% auto auto auto">
      <v-skeleton-loader v-if="loading" type="list-item-avatar"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="card-avatar"></v-skeleton-loader>
        <v-skeleton-loader v-if="loading" type="card-avatar"></v-skeleton-loader>
        </div> -->
         <v-dialog v-model="dialog" fullscreen v-if="loading">
            <div class="centerDiv">
          <v-progress-circular  :size="70" :width="5" indeterminate color="red">
            <v-img class="mx-auto" src="./../assets/Tippings.png" height="60px" width="60px" />
          </v-progress-circular>
           </div>
        </v-dialog>

      <Header :loading="loading" :imgloading="imgloading" @onFileChanged="onFileChanged" :image="image" :userData="userData"/>
      <Content :loading="loading" :imgloading="imgloading" :userData="userData" />
      <v-container class="text-center pt-11 pa-6" v-if="notUser">
        <div>
         <h2>Sorry, {{theauthorName}} does not have an account on Tippings, yet</h2>
        <p class="mt-6">Are you <b>{{theauthorName}}?</b> Claim your Tippings page by tapping the button below </p>

        <v-btn rounded color="red" target="_blank" outlined x-large class="white--text" @click="getStarted()">Claim your page </v-btn>
        </div>
      </v-container>
    </v-main>
    </v-app>
</template>





<script>
import Header from '@/components/Header' 
import { doc, getDoc,updateDoc } from "firebase/firestore"
import db from "@/db"
import { unslugify } from "unslugify"
import slugify from "slugify"
import Content from '@/components/Content'
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

import { getAuth, updateProfile } from "firebase/auth";

export default{
  data(){
    return{
     loading:true,
     userData:{},
     image:"",
     imgloading:false,
     notUser:false,
     dialog:true
 }
  },
    components:{
        Header,
        Content
    },
    computed:{
     theauthorName(){
        return unslugify(this.$route.params.id)
     }
    },


    metaInfo() {
    return {
      title: `${this.theauthorName}`,
      titleTemplate: "%s | Tippings ",
      meta: [
        {
          name: "description",
          content:
            "Reward" +
            this.theauthorName +
            " for their creativity | A Better way to reward creativity",
        },
        {
          property: "og:title",
          content: this.theauthorName + " | Tippings",
        },
        { property: "og:site_name", content: "Tippings" },
        {
          property: "og:description",
          content:
            "Reward " +
            this.theauthorName +
            " for their creativity | A Better way to reward creativity ",
        },
        { property: "og:type", content: "profile" },
        {
          property: "og:url",
          content: "https://tippings.me/" + this.userData.name,
        },
        { property: "og:image", content: this.userData.photoURL },
      ],
    };
  },

    beforeCreate(){
        this.loading = true;
        getDoc(doc(db, "users", this.$route.params.id))
      .then((response) => {
        this.userData = response.data();
        if(this.userData == null){
          this.notUser = true
        } else if(this.userData != null){
            this.image = response.data().photoURL
        }
      })
      .then(() => {
        this.loading = false;
      });
    },

    methods:{
      getStarted(){
        localStorage.setItem('username',  this.slug = slugify(this.$route.params.id, {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@]/g,
            lower: true,
          }))
        window.open("https://tippings.me/signup", '_blank')
        window.open("https://tippings.me/signup", '_blank')
      },
      onFileChanged(event,file){
         var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        this.uploadImage = event.target.files;
        reader.readAsDataURL(input.files[0]);
      }
      this.imgloading = true;
      this.imageData = file;
      console.log(this.imageData.name);

      const storage = getStorage();

      // Create the file metadata
      /** @type {any} */
      const metadata = {
        contentType: "image/jpeg",
      };

      // Upload file and metadata to the object 'images/mountains.jpg'
      const storageRef = ref(storage, "images/" + this.imageData.name);
      const uploadTask = uploadBytesResumable(
        storageRef,
        this.imageData,
        metadata
      );

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;

            // ...

            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            const auth = getAuth();
            updateProfile(auth.currentUser, {
              photoURL: downloadURL,
            })
              .then(() => {
               this.picture = downloadURL;
               this.changeImage();
              })
              .catch((error) => {
                console.log(error)
                this.$swal({
        title: "Something went wrong 😥",
        text: "Sorry, we couldn't update your profile picture. It could be a network issue",
        icon: "error",
        confirmButtonText: "Yay!",
      });
              });
          });
        }
      );
      },
       async changeImage() {
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        photoURL: this.picture,
      });
      this.imgloading = false;
      this.$swal({
        title: "Profile picture Updated!",
        text: "Good job!. You've successfully updated your profile!",
        icon: "success",
        confirmButtonText: "Yay!",
      });
    },
    }
}


</script>





<style>
.centerDiv{
  position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -50px;
    width: 100px;
    height: 100px;
}

</style>
